import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { MeContext } from '../../context/MeContext';

const SubscriptionGate = ({ children }) => {
  const { state } = useContext(MeContext);
  const { subscriptionRequired, status, cardlessTrialStartedAt } = state;

  if (status === 'idle') {
    return null;
  }

  if (subscriptionRequired === true && !cardlessTrialStartedAt) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

SubscriptionGate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SubscriptionGate;
